// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__niCTu","header-logo":"style_header-logo__aiomu"};